export default __webpack_public_path__ + "static/media/evo-icon.267860af.webp";